import { render, staticRenderFns } from "./GalleryThumbnailForm.vue?vue&type=template&id=2bc15af9&scoped=true"
import script from "./GalleryThumbnailForm.vue?vue&type=script&lang=js"
export * from "./GalleryThumbnailForm.vue?vue&type=script&lang=js"
import style0 from "./GalleryThumbnailForm.vue?vue&type=style&index=0&id=2bc15af9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc15af9",
  null
  
)

export default component.exports